var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{staticClass:"light_theme"},[_c('a-layout-header',{class:{
            glHeader: true,
            short: [
                'ies/diagram',
                'diagram',
                'gmm',
                'ies/run-simulation',
                'ies/run-optimization',
                'scenario-generate',
                'resilience-eval',
                'resilience-plan',
                'resilience-recovery' ].includes(_vm.$route.name),
        },staticStyle:{"padding":"0","position":"relative","z-index":"2"}},[_c('a',{attrs:{"id":"content","target":"_blank","rel":"home noopener","href":"/account"}},[_c('img',{attrs:{"alt":"logo","src":require('../assets/svg/ies.svg')}})]),(
                ![
                    'ies/diagram',
                    'diagram',
                    'gmm',
                    'ies/run-simulation',
                    'ies/run-optimization',
                    'scenario-generate',
                    'resilience-eval',
                    'resilience-plan',
                    'resilience-recovery' ].includes(_vm.$route.name)
            )?[_c('div',{staticClass:"p",staticStyle:{"width":"260px","height":"32px"}}),_c('div',{staticClass:"title"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.projectInfo ? _vm.projectInfo['name'] : '无'))]),_vm._v(" - "),_c('span',{staticClass:"product"},[_vm._v("CloudPSS IESLab")])]),_c('div',{staticStyle:{"width":"224px","height":"32px"}})]:_vm._e()],2),_c('navigation'),(
            ![
                'ies/diagram',
                'diagram',
                'gmm',
                'ies/run-simulation',
                'ies/run-optimization',
                'scenario-generate',
                'resilience-eval',
                'resilience-plan',
                'resilience-recovery' ].includes(_vm.$route.name)
        )?_c('router-view'):_vm._e(),(
            ![
                'ies/diagram',
                'diagram',
                'gmm',
                'ies/run-simulation',
                'ies/run-optimization',
                'scenario-generate',
                'resilience-eval',
                'resilience-plan',
                'resilience-recovery' ].includes(_vm.$route.name)
        )?[_c('div',{staticStyle:{"position":"absolute","background":"#0d66d0","z-index":"3","height":"24px","width":"100%","bottom":"0"}})]:_vm._e(),[_c('a-layout-content',{staticStyle:{"width":"100%","height":"100%","position":"absolute","z-index":"1"}},[_c('diagram')],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }